module.exports = "<p>\n  outline works!\n</p>\n"